import keycloakAxios from '@/services/axios';

export const createAccount = async (userId: string) => {
  const response = await keycloakAxios.post('payments/create-account', {
    userId
  });

  if (response.status >= 300) {
    throw new Error(
      `Error creating account: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};
